import { useSelector } from 'react-redux';

import { toggleButtonGroupValues } from 'features/views/dashboard/statistics/constants';
import { getToggleValue } from 'features/views/dashboard/statistics/selectors';

import BruttoTable from './BruttoTable';
import MyTeamTable from './MyTeamTable';

export const ResultsTable = () => {
	const toggleValue = useSelector(getToggleValue);

	return toggleValue === toggleButtonGroupValues.MY_TEAM ? <MyTeamTable /> : <BruttoTable />;
};

export default ResultsTable;
